import React, { useEffect, useState } from "react";
import API from "../api";
import * as XLSX from "xlsx";
import "./AdminDashboard.css"; // <-- add custom css file
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

export default function AdminDashboard() {
    const [attendance, setAttendance] = useState([]);
    // const [day, setDay] = useState("");
    const [day, setDay] = useState(() =>
        new Date().toISOString().split("T")[0]   // Default: today
    );
    const [month, setMonth] = useState("");
    const [username, setUsername] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [totalHours, setTotalHours] = useState("");
    const [status, setStatus] = useState("");

    const [page, setPage] = useState(1);
    const isDaySelected = !!day;
    const isMonthSelected = !!month;
    const isRangeSelected = !month && (fromDate || toDate);



    const [sidebarOpen, setSidebarOpen] = useState(true);
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    // MAP POPUP
    const [showMap, setShowMap] = useState(false);
    const [mapCoords, setMapCoords] = useState({ lat: null, lng: null });

    //     const [day, setDay] = useState(() => {
    //     return new Date().toISOString().split("T")[0];  // default today
    // });

    const [worksheetData, setWorksheetData] = useState(null);
    const [showWorksheetModal, setShowWorksheetModal] = useState(false);

    const [showWorksheet, setShowWorksheet] = useState(false);

    const limit = 10;

    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;

    const paginatedAttendance = attendance.slice(startIndex, endIndex);

    // const paginatedAttendance = attendance; // show all rows

    // -------------------------
    // LOAD DATA
    // -------------------------
    const loadData = async () => {
        let params = {};

        if (day) params.day = day;
        if (month) params.month = month;
        if (username) params.username = username;
        if (fromDate) params.fromDate = fromDate;
        if (toDate) params.toDate = toDate;
        if (status) params.status = status;


        const res = await API.get("/admin/attendance", { params });
        setAttendance(res.data);
    };


    const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        const date = new Date(dateStr);
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };
    useEffect(() => {
        setPage(1);
    }, [day, month, username, fromDate, toDate, status]);

    useEffect(() => {

        loadData();
    }, [day, month, username, fromDate, toDate, page, status]);

    // To ensures only ONE filter type exists at a time

    useEffect(() => {
        if (day) {
            setMonth("");
            setFromDate("");
            setToDate("");
        } else if (month) {
            setFromDate("");
            setToDate("");
        }
    }, [day, month]);


    //Restrict From–To dates to selected month

    const getMonthMinDate = () => {
        if (!month) return "";
        return `${month}-01`;
    };

    const getMonthMaxDate = () => {
        if (!month) return "";
        const [year, m] = month.split("-");
        return new Date(year, m, 0).toISOString().split("T")[0];
    };


    const capitalizeFirst = (text) => {
        if (!text) return "";
        return text.charAt(0).toUpperCase() + text.slice(1);
    };
    // useEffect(() => {
    //     setPage(1);
    // }, [day, month, username, fromDate, toDate, status]);
    // -------------------------
    // DOWNLOAD CSV Page Wise
    // -------------------------
    // const downloadCSV = () => {
    //     const ws = XLSX.utils.json_to_sheet(attendance);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Attendance");
    //     XLSX.writeFile(wb, "attendance_report.csv");
    // };

    const downloadCSV = async () => {
        try {
            const params = {};

            if (day) params.day = day;
            if (month) params.month = month;
            if (username) params.username = username;
            if (fromDate) params.fromDate = fromDate;
            if (toDate) params.toDate = toDate;
            if (status) params.status = status;

            const res = await API.get("/admin/attendance", { params });

            const formattedData = res.data.map((row, index) => ({
                "S.No": index + 1,
                "User Name": row.user_name,
                "Date": formatDate(row.date),
                "IN Time": row.in_time || "-",
                "OUT Time": row.out_time || "-",
                "Total Hours": row.total_hours || "0",
                "Status": row.status,
                "Out Status": row.out_status,
                "Leave Status": row.leave_status,
                "Worksheet": row.worksheet || "-"   // ✅ ADD THIS
            }));


            // const ws = XLSX.utils.json_to_sheet(res.data);
            const ws = XLSX.utils.json_to_sheet(formattedData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Attendance");

            XLSX.writeFile(wb, "attendance_full_report.xlsx");
        } catch (err) {
            console.error("CSV download error", err);
            alert("Failed to download report");
        }
    };
    const fetchWorksheet = async (attendanceId) => {
        setWorksheetData(null);
        setShowWorksheetModal(false);

        try {
            const res = await API.get(
                `/attendance/worksheet/${attendanceId}`
            );
            setWorksheetData(res.data);
            setShowWorksheetModal(true);
        } catch (err) {
            alert("No worksheet available");
        }
    };



    return (
        <div className="dashboard-wrapper">
            <div className={`sidebar-container ${sidebarOpen ? "open" : "closed"}`}>
                <Sidebar />
            </div>

            <div className={`page-area ${sidebarOpen ? "" : "full"}`}>
                <Navbar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
                <div className="main-content">
                    <div className="container-fluid py-4">
                        {/* <div className="top-navbar">
                               <div className="nav-left">
                                   <img src="/Dashboard-Red-64.png" className="dash-icon"/>
                                   <span>Attendance Dashboard</span>
                               </div>
   
                               <div className="nav-right">
                                   <span className="admin">Admin</span>
                               </div>
                           </div> */}
                        <div className="dashboard-title">

                            <img
                                src="/Dashboard-Red-64.png"
                                alt="dashboard"
                                className="dashboard-icon"
                            />
                            <span>Dashboard</span>

                        </div>

                        {/* HEADER */}
                        <div className="search-card">
                            <h2>Employee Attendance</h2>

                            <div style={{ position: "relative" }}>
                                <input
                                    type="text"
                                    placeholder="Search Username"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                                <span style={{
                                    position: "absolute",
                                    right: 18,
                                    top: "50%",
                                    transform: "translateY(-50%)"
                                }}>🔍</span>
                            </div>
                        </div>


                        {/* FILTERS */}
                        <div className="filter-row">

                            <div className="filter-group">
                                <label className="filter-label">Select Day</label>
                                <input
                                    type="date"
                                    value={day}
                                    disabled={isMonthSelected || isRangeSelected}
                                    onChange={(e) => setDay(e.target.value)}
                                    className="filter-input"
                                />


                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Select Month</label>
                                <input
                                    type="month"
                                    value={month}
                                    disabled={isDaySelected || isRangeSelected}
                                    onChange={(e) => setMonth(e.target.value)}
                                    className="filter-input"
                                />

                            </div>

                            <div className="filter-group">
                                <label className="filter-label">From Date</label>
                                <input
                                    type="date"
                                    value={fromDate}
                                    min={getMonthMinDate()}
                                    max={getMonthMaxDate()}
                                    disabled={isDaySelected}
                                    onChange={(e) => setFromDate(e.target.value)}
                                    className="filter-input"
                                />


                            </div>

                            <div className="filter-group">
                                <label className="filter-label">To Date</label>
                                <input
                                    type="date"
                                    value={toDate}
                                    min={fromDate || getMonthMinDate()}
                                    max={getMonthMaxDate()}
                                    disabled={isDaySelected}
                                    onChange={(e) => setToDate(e.target.value)}
                                    className="filter-input"
                                />


                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Status</label>
                                <select
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                    className="filter-input"
                                >
                                    <option value="">All</option>
                                    <option value="in">In</option>
                                    <option value="out">Out</option>
                                    <option value="half-day">Half Day</option>
                                    <option value="leave">Leave</option>
                                </select>
                            </div>

                            <button className="download-btn" onClick={downloadCSV}>
                                ⬇ Download CSV
                            </button>
                        </div>

                        {/* TABLE */}
                        <div className="table-card">
                            <div className="table-scroll-wrapper">
                                <table className="attendance-table">
                                    <thead>
                                        <tr>

                                            <th>S.No</th>
                                            <th>User Name</th>
                                            <th>Date</th>
                                            <th>IN Time</th>
                                            <th>OUT Time</th>
                                            <th>Total Hours</th>
                                            <th>In-Status</th>
                                            <th>Out-Status</th>
                                            <th>Leave-Status</th>
                                            <th>In-Map</th>
                                            <th>Out-Map</th>
                                            <th>In-Image</th>
                                            <th>Out-Image</th>
                                            <th>worksheet</th>



                                        </tr>
                                    </thead>

                                    <tbody>
                                        {paginatedAttendance.length === 0 ? (
                                            <tr>
                                                <td colSpan="6" style={{ textAlign: "center" }}>No Data Found</td>
                                            </tr>
                                        ) : (
                                            paginatedAttendance.map((row, index) => (
                                                <tr key={row.id}>
                                                    <td>{startIndex + index + 1}</td>   {/* ✅ SERIAL NO */}

                                                    <td>
                                                        <a
                                                            href={`/attendance-history/${row.user_id}`}
                                                            style={{ color: "#007bff" }}
                                                        >
                                                            {row.user_name}
                                                        </a>
                                                    </td>
                                                    <td>{formatDate(row.date)}</td>

                                                    <td>{row.in_time || "-"}</td>
                                                    <td>{row.out_time || "-"}</td>
                                                    <td>{row.total_hours || "0"}</td>

                                                    <td>
                                                        <span className={`status ${row.status}`}>
                                                            {capitalizeFirst(row.status)}
                                                        </span>
                                                    </td>

                                                    <td>
                                                        <span className={`status ${row.out_status}`}>
                                                            {capitalizeFirst(row.out_status)}
                                                        </span>
                                                    </td>
                                                    <td><span className={`status ${row.leave_status}`}>{row.leave_status}</span></td>

                                                    {/* MAP BUTTON */}
                                                    <td>
                                                        {row.latitude && row.longitude ? (
                                                            <button
                                                                onClick={() =>
                                                                    window.open(
                                                                        `https://www.google.com/maps?q=${row.latitude},${row.longitude}`,
                                                                        "_blank"
                                                                    )
                                                                }
                                                                style={{
                                                                    color: "#007bff",
                                                                    cursor: "pointer",
                                                                    background: "none",
                                                                    border: "none"
                                                                }}
                                                            >
                                                                🌍 In-Open Map
                                                            </button>

                                                        ) : "No Location"}
                                                    </td>

                                                    {/* MAP BUTTON */}
                                                    <td>
                                                        {row.out_latitude && row.out_longitude ? (
                                                            <button
                                                                onClick={() =>
                                                                    window.open(
                                                                        `https://www.google.com/maps?q=${row.out_latitude},${row.out_longitude}`,
                                                                        "_blank"
                                                                    )
                                                                }
                                                                style={{
                                                                    color: "#007bff",
                                                                    cursor: "pointer",
                                                                    background: "none",
                                                                    border: "none"
                                                                }}
                                                            >
                                                                🌍 Out-Open Map
                                                            </button>

                                                        ) : "No Location"}
                                                    </td>
                                                    {/* IMAGE */}
                                                    <td>
                                                        {row.click_image ? (
                                                            <img
                                                                src={`http://163.227.92.37:7888/uploads/attendance/${row.click_image}`}
                                                                onClick={() =>
                                                                    window.open(
                                                                        `http://163.227.92.37:7888/uploads/attendance/${row.click_image}`,
                                                                        "_blank"
                                                                    )
                                                                }
                                                                style={{ width: 50, height: 50, cursor: "pointer" }}
                                                            />
                                                        ) : "-"}
                                                    </td>
                                                    <td>
                                                        {row.out_click_image ? (
                                                            <img
                                                                src={`http://163.227.92.37:7888/uploads/attendance/${row.out_click_image}`}
                                                                onClick={() =>
                                                                    window.open(
                                                                        `http://163.227.92.37:7888/uploads/attendance/${row.out_click_image}`,
                                                                        "_blank"
                                                                    )
                                                                }
                                                                style={{ width: 50, height: 50, cursor: "pointer" }}
                                                            />
                                                        ) : "-"}
                                                    </td>
                                                    <td>
                                                        <button
                                                            className="view-btn"
                                                            onClick={() => fetchWorksheet(row.id)}
                                                        >
                                                            Worksheet
                                                        </button>
                                                    </td>






                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>

                            </div>
                        </div>

                        {/* PAGINATION */}
                        <div className="pagination-section">
                            <p>
                                Showing {attendance.length > 0 ? startIndex + 1 : 0} –
                                {Math.min(endIndex, attendance.length)} of {attendance.length}
                            </p>

                            <div className="pagination-controls">
                                <button disabled={page === 1} onClick={() => setPage(1)}>«</button>
                                <button disabled={page === 1} onClick={() => setPage(page - 1)}>‹</button>
                                <button className="active">{page}</button>
                                <button
                                    disabled={endIndex >= attendance.length}
                                    onClick={() => setPage(page + 1)}
                                >
                                    ›
                                </button>

                                <button
                                    disabled={endIndex >= attendance.length}
                                    onClick={() => setPage(Math.ceil(attendance.length / limit))}
                                >
                                    »
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* MAP POPUP */}
            {showMap && (
                <div className="map-popup">
                    <div className="map-card">
                        <button className="close-btn" onClick={() => setShowMap(false)}>✖</button>

                        <iframe
                            width="100%"
                            height="300"
                            style={{ border: 0 }}
                            loading="lazy"
                            allowFullScreen
                            src={`https://www.google.com/maps?q=${mapCoords.lat},${mapCoords.lng}&z=16&output=embed`}
                        ></iframe>
                    </div>
                </div>
            )}
            {showWorksheetModal && (
                <div className="modal-overlay">
                    <div className="modal-box">
                        <h5>Employee Worksheet</h5>

                        <p><strong>Date:</strong> {worksheetData?.date}</p>
                        <p><strong>Out Time:</strong> {worksheetData?.out_time}</p>

                        <div className="worksheet-text">
                            {worksheetData?.worksheet}
                        </div>

                        <button
                            className="close-btn"
                            onClick={() => setShowWorksheetModal(false)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}

        </div>
    );

}
